import { render } from "./NoteCard.vue?vue&type=template&id=323f14a8&scoped=true"
import script from "./NoteCard.vue?vue&type=script&lang=js"
export * from "./NoteCard.vue?vue&type=script&lang=js"

import "./NoteCard.vue?vue&type=style&index=0&id=323f14a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323f14a8"]])

export default __exports__